// extracted by mini-css-extract-plugin
export default {"SignUpTitle":"iStyles_SignUpTitle__2R88+","SignUpSubtitle":"iStyles_SignUpSubtitle__ppOlG"};